export enum Role {
  PRICE_CARD_MAINTAINER = 'Price_Card_Maintainer',
  ADMIN = 'Admin',
  COMPETITOR_MAINTAINER = 'Competitor_Maintainer',
  RATE_CARD_VIEWER = 'Rate_Card_Viewer',
  RATE_CARD_MAINTAINER = 'Rate_Card_Maintainer',
  CONTRACT_PRICE_MAINTAINER = 'Contract_Price_Maintainer'
} 